import { AdvancedViewOptions } from "./AdvancedViewOptions";

export const ChapterViewMenu = () => {
	return (
		<div className="flex flex-wrap gap-3">
			<AdvancedViewOptions />	
		</div>
	);
}